import React from 'react';
import { Box, Typography } from '@mui/material';
import { usePortalTokens } from '../../styles/usePortalTokens';

const PortalEmptyState = ({ icon: Icon, title, description, action = null, compact = false }) => {
  const portal = usePortalTokens();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: compact ? 4 : 6,
        px: 2,
      }}
    >
      {Icon ? (
        <Box
          sx={{
            width: compact ? 48 : 56,
            height: compact ? 48 : 56,
            borderRadius: '14px',
            bgcolor: portal.accentSoft,
            color: portal.accent,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Icon sx={{ fontSize: compact ? 24 : 28 }} />
        </Box>
      ) : null}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: compact ? '1rem' : '1.125rem',
          color: 'text.primary',
          mb: description ? 1 : 0,
        }}
      >
        {title}
      </Typography>
      {description ? (
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', maxWidth: 360, lineHeight: 1.6, mb: action ? 2.5 : 0 }}
        >
          {description}
        </Typography>
      ) : null}
      {action}
    </Box>
  );
};

export default PortalEmptyState;
